// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-radio[data-v-0ac58c55] {\n  border: 2px solid #e0e7ef;\n  border-radius: 10px;\n  margin-bottom: 16px;\n  background: #fff;\n  transition: background 0.2s, border 0.2s;\n  min-height: 64px;\n  display: flex;\n  align-items: center;\n  padding: 0 24px;\n  font-size: 1.2rem;\n}\n.selected-radio[data-v-0ac58c55] {\n  background: #eaf4fe !important;\n  border: 2px solid #2196f3 !important;\n}", ""]);
// Exports
module.exports = exports;
